import { render } from "./LanguageSelector.vue?vue&type=template&id=83d3b53a&scoped=true"
import script from "./LanguageSelector.vue?vue&type=script&lang=js"
export * from "./LanguageSelector.vue?vue&type=script&lang=js"

import "./LanguageSelector.vue?vue&type=style&index=0&id=83d3b53a&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83d3b53a"]])

export default __exports__